(async () => {
  if (!customElements.get('athlete-products')) {
    const { default: Swiper, A11y, Navigation, Autoplay } = await import('swiper');

    Swiper.use([A11y, Navigation, Autoplay]);

    class AthleteProducts extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper]');

        this.swiperOptions = {
          threshold: 10,
        };

        // Check if we have extra options on the HTML
        if (this.swiperElement.dataset && this.swiperElement.dataset.options) {
          const jsonOptions = JSON.parse(this.swiperElement.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }
    }

    window.AthleteProducts = AthleteProducts;

    customElements.define('athlete-products', AthleteProducts);
  }
})();
